import { render, staticRenderFns } from "./mainSeckill.vue?vue&type=template&id=597364eb"
import script from "./mainSeckill.vue?vue&type=script&lang=js"
export * from "./mainSeckill.vue?vue&type=script&lang=js"
import style0 from "./mainSeckill.vue?vue&type=style&index=0&id=597364eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports